import { Button as BaseButton } from "@base-ui/react/button";
import walletIcon from "@loot-os/icons/icons/wallet";
import type { ComponentProps } from "react";
import { Icon } from "../core/Icon.js";
import { useRiseCount } from "../core/useRiseCount.js";
import { cn } from "../foundations/cn.js";
import { FOCUS_RING, PRESS } from "../foundations/interaction.js";
import { Amount } from "./Amount.js";

export interface BalancePillProps
  extends Omit<ComponentProps<typeof BaseButton>, "className" | "children"> {
  /** The spendable balance in cents. */
  cents: number;
  /** The button's name before the amount, e.g. "Balance". */
  label?: string;
  className?: string;
}

/** The shopper's spendable balance in the chrome; pressing it opens Add funds. */
export function BalancePill({ cents, label = "Balance", className, ...props }: BalancePillProps) {
  // The wallet plays when the balance rises (funds added, a sale), never when it is spent.
  const rises = useRiseCount(cents);
  return (
    <BaseButton
      className={cn(
        "inline-flex h-control-sm shrink-0 cursor-pointer items-center gap-2 rounded-control border border-border-default bg-bg-raised px-3 text-text-primary hover:bg-bg-hover",
        PRESS,
        FOCUS_RING,
        className,
      )}
      {...props}
    >
      <Icon icon={walletIcon} className="text-text-secondary" playOn={rises} />
      <span className="sr-only">{label}</span>
      <Amount cents={cents} />
    </BaseButton>
  );
}
